import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import articlePage from "@faire/web-api--source/routes/www/support/articles/articleId";

import { InstantAnswerContext, InstantAnswerScenario } from "../../types";

export const DoNotHaveRequestedInfoIA: InstantAnswerBuilderFn = (
  strictLocalize,
  articles
) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    learnMoreLink: articles?.Account.NOT_OPEN
      ? articlePage(articles.Account.NOT_OPEN.id)
      : undefined,
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => VERIFY_YOUR_ACCOUNT(strictLocalize),
    getDescription: () => [DO_NOT_HAVE_INFO_NEEDED(strictLocalize)],
  };
};

const VERIFY_YOUR_ACCOUNT = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Providing information to verify your account",
    description: {
      text: "Title for the answer of Do not have requested information issue",
    },
  });

const DO_NOT_HAVE_INFO_NEEDED = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "Don’t have all of the information needed to verify your account right now? That’s OK. Let us know, and we’ll hold your order up to 30 days from the order date while you get the required info.",
  });
